export * from './download-template/download-template.module';
export * from './download-template/download-template.component';
